import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  makeStyles,
  Paper,
  Box,
  Divider,
  Button,
  Backdrop,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  CardContent,
  useTheme,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import apiConfigs from "../../config/config";
import history from "../../utils/HistoryUtils";
import AlertDialog from "../../components/Alert/AlertDialog";
import Notification from "../../components/Notification/Notification";
import { deletePaymentScheme } from "../../store/action";
import Loading from "../../components/Loading/Loading";
import { Event, Person } from "@material-ui/icons";
import moment from "moment/moment";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflowX: "auto",
    padding: 20,
    background: theme.palette.background.main

  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: "1.2rem",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: "0.85rem",
  },
  value: {
    fontWeight: 500,
    fontSize: "1rem",
  },
  card: {
    borderRadius: 12,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  table: {
    borderRadius: 12,
    overflow: "hidden",
    "& th": {
      fontWeight: 600,
    },
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
}));

const DetailPaymentScheme = ({ match }) => {
  const theme = useTheme();
  const classes = useStyle();
  const dispatch = useDispatch();
  const id = match.params.id;
  const [Id, setId] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentItems, setPaymentSch] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [staffNotify, setStaffNotify] = useState(false);
  const { deletePaymentSchemeSuccess, deletePaymentSchemeError } = useSelector(
    (state) => state.paymentScheme
  );
  const staffDetail = JSON.parse(localStorage.getItem("staffDetail"));
  const loginUserInfo = JSON.parse(window.localStorage.getItem("loginUserInfo"));

  const getSignlePaymentScheme = async () => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    setLoading(true);
    await axios
      .get(`${apiConfigs.API_URL}api/organization/payment-scheme/${id}`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${loggedInUser}`,
        },
      })
      .then((response) => {
        setPaymentSch(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("error.message", error.message);
        setLoading(false);
      });
  };

  const upadateLink = () => {
    history.push(`update`);
  };
  const backPage = () => {
    history.goBack(-1);
  };

  const deletePaymentClose = () => {
    setDeleteOpen(false);
  };

  const alertResponse = (id) => {
    dispatch(deletePaymentScheme(id));
    setStaffNotify(true);
  };

  const deleteStaffItem = (id) => {
    setDeleteOpen(true);
    setId(id);
  };

  useEffect(() => {
    getSignlePaymentScheme();
  }, [id]);
  return (
    <>
      {loading && <Loading open={loading} />}

      {staffNotify && deletePaymentSchemeSuccess?.message && (
        <Notification data={deletePaymentSchemeSuccess?.message} status="success" />
      )}{" "}

      {staffNotify && deletePaymentSchemeError?.message && (
        <Notification data={deletePaymentSchemeError?.message} status="error" />
      )}

      <Paper className={`${classes.root} mb-6`}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography style={{ color: theme.palette.listItem }}>Customer Name</Typography>
            <Typography variant="h5">{paymentItems.name}</Typography>
          </Grid>

          {/* <Grid item xs={12} sm={6} lg={3}>
            <Typography className={classes.value}>{paymentItems.name}</Typography>
          </Grid> */}

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>Speciality</Typography>
            <Typography className={classes.value}>{paymentItems.speciality_name}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>Grade</Typography>
            <Typography className={classes.value}>{paymentItems.grade_name}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>Remark</Typography>
            <Typography className={classes.value}>{paymentItems.remark}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>Start Date</Typography>
            <Typography className={classes.value}>{paymentItems.start_date_show && moment(paymentItems.start_date_show).isValid() ? moment(paymentItems.start_date_show).format("DD-MMM-YYYY") : "-"}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>End Date</Typography>
            <Typography className={classes.value}>{paymentItems?.end_date_show &&
              moment(paymentItems.end_date_show, "DD-MM-YYYY", true).isValid()
              ? moment(paymentItems.end_date_show, "DD-MM-YYYY").format("DD-MMM-YYYY").toUpperCase()
              : "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>Payment Scheme Type</Typography>
            <Typography className={classes.value}>{paymentItems.payment_scheme_type}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>NHS Product Group:</Typography>
            <Typography className={classes.value}>{paymentItems?.nhs_product_group}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>LPP Product Group:</Typography>
            <Typography className={classes.value}>{paymentItems?.lpp_product_group}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>LPP Job Title:</Typography>
            <Typography className={classes.value}>{paymentItems?.lpp_job_title}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>LPP Job Code:</Typography>
            <Typography className={classes.value}>{paymentItems?.lpp_job_code}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>LPP/HTE Job Family:</Typography>
            <Typography className={classes.value}>{paymentItems?.lpp_hte_job_family}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>MISO Job Title:</Typography>
            <Typography className={classes.value}>{paymentItems?.miso_job_title}</Typography>
          </Grid>

          <Grid item xs={12} sm={6} lg={3}>
            <Typography style={{ color: theme.palette.listItem }}>WTR:</Typography>
            <Typography className={classes.value}>{paymentItems.wtr}</Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography className={classes.sectionTitle}>Rates</Typography>
            <Divider />
          </Grid>

          <Grid item xs={12}>
            <Box style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
              <Typography style={{ textAlign: "center", color: theme.palette.listItem }}>Day Shift</Typography>
              <Typography variant="h6" style={{
                textAlign: "center",
                background: "#817e7e",
                color: "white",
                maxWidth: "40%",
                borderRadius: "9px",
                padding: "0 10px 0 10px"
              }}>
                {paymentItems.payment_scheme_type !== "Fixed" && (
                  <>
                    {paymentItems.day_from} : {paymentItems.day_to}
                  </>
                )}
              </Typography>
            </Box>
          </Grid>

          <Grid item sm={12}>
            <Table className={classes.table}>
              <TableHead >
                <TableRow style={{ background: theme.palette.thead }}>
                  <TableCell align="left" style={{ color: theme.palette.grey[800] }}>Pay Rate</TableCell>
                  <TableCell align="left" style={{ color: theme.palette.grey[800] }}>Charge Rate</TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key={0}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_paye_payable_day_rate) ? ((Math.round(paymentItems?.non_awr_paye_payable_day_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_paye_chargeable_day_rate) ? ((Math.round(paymentItems?.non_awr_paye_chargeable_day_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>PAYE</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Non AWR</TableCell>
                </TableRow>
                <TableRow key={1}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.payable_day_rate) ? ((Math.round(paymentItems?.payable_day_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.chargeable_day_rate) ? ((Math.round(paymentItems?.chargeable_day_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>PAYE</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>AWR</TableCell>
                </TableRow>
                <TableRow key={2}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_umbrella_payable_day_rate) ? ((Math.round(paymentItems?.non_awr_umbrella_payable_day_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_umbrella_chargeable_day_rate) ? ((Math.round(paymentItems?.non_awr_umbrella_chargeable_day_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Umbrella</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Non AWR</TableCell>
                </TableRow>
                <TableRow key={3}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.awr_umbrella_payable_day_rate) ? ((Math.round(paymentItems?.awr_umbrella_payable_day_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.awr_umbrella_chargeable_day_rate) ? ((Math.round(paymentItems?.awr_umbrella_chargeable_day_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Umbrella</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>AWR</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>

          <Grid item xs={12}>
            <Box style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
              <Typography className="customHeading" style={{ textAlign: "center", color: theme.palette.listItem }}>Night Shift</Typography>
              <Typography variant="h6" style={{
                textAlign: "center",
                background: "#817e7e",
                color: "white",
                maxWidth: "40%",
                borderRadius: "9px",
                padding: "0 10px 0 10px"
              }}>
                {
                  paymentItems.payment_scheme_type !== "Fixed" && (
                    <>
                      {paymentItems.night_from} : {paymentItems.night_to}
                    </>
                  )
                }
              </Typography>
            </Box>
          </Grid>
          <Grid item sm={12}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow style={{ background: theme.palette.thead }}>
                  <TableCell align="left" style={{ color: theme.palette.grey[800] }}>Pay Rate</TableCell>
                  <TableCell align="left" style={{ color: theme.palette.grey[800] }}>Charge Rate</TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key={0}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_paye_payable_night_rate) ? ((Math.round(paymentItems?.non_awr_paye_payable_night_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_paye_chargeable_night_rate) ? ((Math.round(paymentItems?.non_awr_paye_chargeable_night_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>PAYE</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Non AWR</TableCell>
                </TableRow>
                <TableRow key={1}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.payable_night_rate) ? ((Math.round(paymentItems?.payable_night_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.chargeable_night_rate) ? ((Math.round(paymentItems?.chargeable_night_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>PAYE</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>AWR</TableCell>
                </TableRow>
                <TableRow key={2}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_umbrella_payable_night_rate) ? ((Math.round(paymentItems?.non_awr_umbrella_payable_night_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_umbrella_chargeable_night_rate) ? ((Math.round(paymentItems?.non_awr_umbrella_chargeable_night_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Umbrella</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Non AWR</TableCell>
                </TableRow>
                <TableRow key={3}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.awr_umbrella_payable_night_rate) ? ((Math.round(paymentItems?.awr_umbrella_payable_night_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.awr_umbrella_chargeable_night_rate) ? ((Math.round(paymentItems?.awr_umbrella_chargeable_night_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Umbrella</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>AWR</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>

          <Grid item xs={12}>
            <Box style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
              <Typography className="customHeading" style={{
                textAlign: "center",
                color: theme.palette.listItem
              }}>Saturday Shift</Typography>
              <Typography variant="h6" style={{
                textAlign: "center",
                background: "#817e7e",
                color: "white",
                maxWidth: "40%",
                borderRadius: "9px",
                padding: "0 10px 0 10px"
              }}>
                {paymentItems.payment_scheme_type !== "Fixed" && (
                  <>
                    {paymentItems.saturday_from} : {paymentItems.saturday_to}
                  </>
                )}
              </Typography>
            </Box>
          </Grid>

          <Grid item sm={12}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow style={{ background: theme.palette.thead }}>
                  <TableCell align="left" style={{ color: theme.palette.grey[800] }}>Pay Rate</TableCell>
                  <TableCell align="left" style={{ color: theme.palette.grey[800] }}>Charge Rate</TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key={0}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_paye_payable_saturday_rate) ? ((Math.round(paymentItems?.non_awr_paye_payable_saturday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_paye_chargeable_saturday_rate) ? ((Math.round(paymentItems?.non_awr_paye_chargeable_saturday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>PAYE</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Non AWR</TableCell>
                </TableRow>
                <TableRow key={1}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.payable_saturday_rate) ? ((Math.round(paymentItems?.payable_saturday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.chargeable_saturday_rate) ? ((Math.round(paymentItems?.chargeable_saturday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>PAYE</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>AWR</TableCell>
                </TableRow>
                <TableRow key={2}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_umbrella_payable_saturday_rate) ? ((Math.round(paymentItems?.non_awr_umbrella_payable_saturday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_umbrella_chargeable_saturday_rate) ? ((Math.round(paymentItems?.non_awr_umbrella_chargeable_saturday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Umbrella</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Non AWR</TableCell>
                </TableRow>
                <TableRow key={3}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.awr_umbrella_payable_saturday_rate) ? ((Math.round(paymentItems?.awr_umbrella_payable_saturday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.awr_umbrella_chargeable_saturday_rate) ? ((Math.round(paymentItems?.awr_umbrella_chargeable_saturday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Umbrella</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>AWR</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
          <Grid item xs={12}>
            <Box style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
              <Typography className="customHeading" style={{
                textAlign: "center",
                color: theme.palette.listItem
              }}>Holiday/Sunday Shift</Typography>
              <Typography variant="h6" style={{
                textAlign: "center",
                background: "#817e7e",
                color: "white",
                maxWidth: "40%",
                borderRadius: "9px",
                padding: "0 10px 0 10px"
              }}>
                {paymentItems.payment_scheme_type !== "Fixed" && (
                  <>
                    {paymentItems.holiday_from} : {paymentItems.holiday_to}
                  </>
                )}
              </Typography>
            </Box>
          </Grid>
          <Grid item sm={12}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow style={{ background: theme.palette.thead }}>
                  <TableCell align="left" style={{ color: theme.palette.grey[800] }}>Pay Rate</TableCell>
                  <TableCell align="left" style={{ color: theme.palette.grey[800] }}>Charge Rate</TableCell>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key={0}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_paye_payable_holiday_rate) ? ((Math.round(paymentItems?.non_awr_paye_payable_holiday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_paye_chargeable_holiday_rate) ? ((Math.round(paymentItems?.non_awr_paye_chargeable_holiday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>PAYE</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Non AWR</TableCell>
                </TableRow>
                <TableRow key={1}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.payable_holiday_rate) ? ((Math.round(paymentItems?.payable_holiday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.chargeable_holiday_rate) ? ((Math.round(paymentItems?.chargeable_holiday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>PAYE</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>AWR</TableCell>
                </TableRow>
                <TableRow key={2}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_umbrella_payable_holiday_rate) ? ((Math.round(paymentItems?.non_awr_umbrella_payable_holiday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.non_awr_umbrella_chargeable_holiday_rate) ? ((Math.round(paymentItems?.non_awr_umbrella_chargeable_holiday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Umbrella</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Non AWR</TableCell>
                </TableRow>
                <TableRow key={3}>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.awr_umbrella_payable_holiday_rate) ? ((Math.round(paymentItems?.awr_umbrella_payable_holiday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>
                    {(paymentItems?.awr_umbrella_chargeable_holiday_rate) ? ((Math.round(paymentItems?.awr_umbrella_chargeable_holiday_rate * 100) / 100).toFixed(2)) : "0.00"}
                  </TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>Umbrella</TableCell>
                  <TableCell scope="row" style={{ color: theme.palette.listItem }}>AWR</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>

          <Grid item xs={12}>
            <Box className={classes.actions}>
              <Button variant="outlined" color="primary" onClick={backPage}>Back</Button>
              {staffDetail !== "Booking" && staffDetail !== "Finance" && (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={upadateLink}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </Button>
                </>
              )}
              {(staffDetail === "Admin" || loginUserInfo?.role === "ORGANIZATION") && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={(e) => deleteStaffItem(paymentItems.id)}
                  tartIcon={<DeleteIcon />}
                >
                  Delete
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </Paper >

      <AlertDialog
        id={Id}
        open={deleteOpen}
        close={deletePaymentClose}
        response={alertResponse}
        title="Delete Payment Scheme"
        description="Are you sure you want to delete?"
        buttonName="Delete"
      />
    </>
  );
};

export default DetailPaymentScheme;
